import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1v2htisz: FaireBrandEntity = {
  token: "b_1v2htisz",
  type: "brand",
  name: "En Crème",
  avatarUrl:
    "https://cdn.faire.com/fastly/1704d7304314e154c07ac057d4bdf35a5cba3139d88addeaf978a654336f3ee9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/60b6f596dc1ade2416307c1665597cbc0291fc88d5803561aa5372b6e623ea51.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1704d7304314e154c07ac057d4bdf35a5cba3139d88addeaf978a654336f3ee9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/60b6f596dc1ade2416307c1665597cbc0291fc88d5803561aa5372b6e623ea51.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 174,
  isTopShop: true,
  isInsider: true,
  description:
    "Enamored by California's effortless vibe, En Crème is inspired by the bohemian lifestyle of free-spirited individuals. Showcasing natural silhouettes with flirty, colorful accents and vintage details. En Crème. celebrates one sense of originality. We inspire to create fashion that is not only authentically stylish but also exciting and accessible.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:36.779Z",
    importedBy: "entity-db-cli",
  },
};
